var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99993 10.1335C9.17817 10.1335 10.1333 9.17835 10.1333 8.00011C10.1333 6.82187 9.17817 5.86673 7.99993 5.86673C6.8217 5.86673 5.86655 6.82187 5.86655 8.00011C5.86655 9.17835 6.8217 10.1335 7.99993 10.1335Z",
    fill: "#B9BBBF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9682 7.81877C15.3409 6.19615 14.2518 4.79289 12.8357 3.78245C11.4196 2.77201 9.7384 2.19867 7.99997 2.1333C6.26153 2.19867 4.58036 2.77201 3.16422 3.78245C1.74809 4.79289 0.659075 6.19615 0.0317739 7.81877C-0.0105913 7.93595 -0.0105913 8.06427 0.0317739 8.18145C0.659075 9.80408 1.74809 11.2073 3.16422 12.2178C4.58036 13.2282 6.26153 13.8015 7.99997 13.8669C9.7384 13.8015 11.4196 13.2282 12.8357 12.2178C14.2518 11.2073 15.3409 9.80408 15.9682 8.18145C16.0105 8.06427 16.0105 7.93595 15.9682 7.81877ZM7.99997 11.4669C7.31431 11.4669 6.64405 11.2635 6.07395 10.8826C5.50384 10.5017 5.0595 9.96024 4.79711 9.32678C4.53472 8.69331 4.46606 7.99626 4.59983 7.32378C4.7336 6.6513 5.06377 6.03358 5.5486 5.54875C6.03344 5.06391 6.65115 4.73374 7.32364 4.59997C7.99612 4.46621 8.69317 4.53486 9.32664 4.79725C9.9601 5.05964 10.5015 5.50398 10.8825 6.07409C11.2634 6.64419 11.4667 7.31445 11.4667 8.00011C11.4653 8.91912 11.0996 9.80008 10.4498 10.4499C9.79994 11.0998 8.91897 11.4655 7.99997 11.4669Z",
    fill: "#B9BBBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcView);
export default __webpack_public_path__ + "static/media/ic-view.85da9c99dfb9b584e1349de7352e487a.svg";
export { ForwardRef as ReactComponent };